import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CelebrationIcon from '@mui/icons-material/Celebration';

const OfferCodeBanner = ({ offerCode, copiedCode, onCopy }) => {
  if (!offerCode) return null;
  console.log('offerCode', offerCode);

  return (
    <div
      className="flex flex-col gap-1 px-4 py-3 rounded-md mt-3 shadow-sm"
      style={{
        background: 'linear-gradient(90deg, #ffd3d3, #f8f1f1)',
      }}
    >
      <div className="flex items-center gap-2 mb-1">
        <CelebrationIcon fontSize="small" className="text-green-600" />
        <span className="text-sm font-semibold text-green-700">
          You've unlocked the best gift offer!
        </span>
      </div>

      <div className="flex items-center gap-2">
        <ContentCopyIcon fontSize="small" className="text-gray-700" />
        <p className="text-sm text-gray-800">
          Use Code:{' '}
          <span
            onClick={() => onCopy(offerCode)}
            className="font-semibold text-[#1c1b1f] cursor-pointer underline"
          >
            {copiedCode === offerCode ? 'Copied!' : offerCode}
          </span>{' '}
          at checkout
        </p>
      </div>
    </div>
  );
};

export default OfferCodeBanner;
